import { render } from "./DriverView.vue?vue&type=template&id=20071da1&scoped=true"
import script from "./DriverView.vue?vue&type=script&lang=js"
export * from "./DriverView.vue?vue&type=script&lang=js"

import "./DriverView.vue?vue&type=style&index=0&id=20071da1&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sisfrota-ui-refactor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20071da1"]])

export default __exports__